<template>
  <vs-popup id="popupCreate736" title="공정분류표(직영) 신규등록" :active.sync="showPopup">
    <div>
      <field-select-module v-model="stdInfo" :board="this.board" :types="['department', 'com_name', 'rank', 'writer_name', 'date']"/>
      <div class="header mb-4 flex ">
        <h5 class="flex items-center"><i class="dot"></i> 공정분류표(직영)</h5>
        <div class="flex ml-auto gap-2">
          <button @click="pushRow">
            <feather-icon icon="PlusIcon" svgClasses="h-5 w-5" />
          </button>
          <button @click="popRow">
            <feather-icon icon="MinusIcon" svgClasses="h-5 w-5" />
          </button>
        </div>
      </div>
      <div class="body mb-4">
        <table class="w-full">
          <tbody>
            <tr v-for="(data, index) in list" :key="index">
              <td><field-selector v-model="data.사업장.id" @select="(field) => onSelectBusiness(data, field)"/></td>
              <td class="relative">
                <ml-input
                  v-model="data.팀명"
                  placeholder="입력"
                  clearable
                  @focus="showOverlay($event, '팀명', index, data)"
                  @click="showOverlay($event, '팀명', index, data)"
                  @input="filterOptions($event, '팀명')"
                  @blur="hideOverlay($event, '팀명', index, data)"
                />
              </td>
              <td class="relative">
                <ml-input
                  v-model="data.공장명"
                  placeholder="입력"
                  clearable
                  @focus="showOverlay($event, '공장명', index, data)"
                  @click="showOverlay($event, '공장명', index, data)"
                  @input="filterOptions($event, '공장명')"
                  @blur="hideOverlay($event, '공장명', index, data)"
                />
              </td>
              <td class="relative">
                <ml-input
                  v-model="data.대분류"
                  placeholder="입력"
                  clearable
                  @focus="showOverlay($event, '대분류', index, data)"
                  @click="showOverlay($event, '대분류', index, data)"
                  @input="filterOptions($event, '대분류')"
                  @blur="hideOverlay($event, '대분류', index, data)"
                />
              </td>
              <td class="relative">
                <ml-input
                  v-model="data.중분류"
                  placeholder="입력"
                  clearable
                  @focus="showOverlay($event, '중분류', index, data)"
                  @click="showOverlay($event, '중분류', index, data)"
                  @input="filterOptions($event, '중분류')"
                  @blur="hideOverlay($event, '중분류', index, data)"
                />
              </td>
              <td class="relative">
                <ml-input
                  v-model="data.소분류"
                  placeholder="입력"
                  clearable
                />
              </td>
            </tr>
          </tbody>
          <thead>
          <tr>
            <th><div>사업장명</div></th>
            <th><div>팀명</div></th>
            <th><div>공장명</div></th>
            <th><div>대분류</div></th>
            <th><div>중분류</div></th>
            <th><div>소분류</div></th>
          </tr>
          </thead>
        </table>
      </div>

      <!-- 옵션 오버레이 -->
      <div
        v-if="overlay.show"
        class="options-overlay"
        :style="{
          top: overlay.position.top + 'px',
          left: overlay.position.left + 'px',
          width: overlay.position.width + 'px'
        }"
        @mousedown.prevent
      >
        <div
          v-for="(option, idx) in overlay.filteredOptions"
          :key="idx"
          class="option-item"
          @click="selectOption(option)"
        >
          {{ option }}
        </div>
        <div v-if="overlay.filteredOptions.length === 0" class="option-item disabled">
          옵션이 없습니다
        </div>
      </div>
      <div class="mt-4 flex justify-end gap-2">
        <vs-button color="#DCDFE2" textColor="#000" @click="showPopup = false">닫기</vs-button>
        <vs-button color="secondary" @click="onClickSave">등록</vs-button>
      </div>
    </div>
  </vs-popup>
</template>

<script>
import FieldSelector from "@/components/selector/FieldSelector.vue";
import FieldSelectModule from "@/views/modules/FieldSelectModule.vue";
import HttpRequest from "@/util/HttpRequest";

export default {
  components: {FieldSelectModule, FieldSelector},
  props: {
    value: Boolean,
    header: Object,
    board: Object,
  },
  computed:{
    projectId() {
      return parseInt(this.$route.params.proj_id);
    },
    showPopup: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    },
    pageTitle() {
      return this.$store.state.menu.pageTitle;
    },
  },
  watch: {
    showPopup (showPopup) {
      if (showPopup) {
        this.list = []
        // 팝업이 열릴 때 기본 행 1개 추가
        this.pushRow()
      }
    }
  },
  data() {
    return {
      stdInfo: {},
      list: [],
      allList: [], // 중복저장을 방지하기 위해 전체 목록을 불러옴

      // 옵션 캐시
      options: {
        'body.팀명': {},
        'body.공장명': {},
        'body.대분류': {},
        'body.중분류': {},
      },

      // 오버레이 관련
      overlay: {
        show: false,
        field: '',
        rowIndex: -1,
        options: [],
        filteredOptions: [],
        position: { top: 0, left: 0, width: 0 }
      },
      overlayTimeout: null
    }
  },
  methods: {
    // 사업장 선택 이벤트 핸들러
    async onSelectBusiness(data, field) {
      // 기존 구문: field_name 설정
      data.사업장.field_name = field.field_name;

      // loadPostOptions 호출하여 사업장에 대한 옵션을 불러옴
      await this.loadPostOptions(
        data.사업장.field_name,
        data.팀명,
        data.공장명,
        data.대분류,
        data.중분류
      );

      // Vue 반응성을 위해 강제 업데이트
      this.$forceUpdate();
    },
    // 중복저장을 방지하기 위해 전체 목록을 불러옴
    async loadPostListWithMeta(searchList) {
      this.loading(true)
      const list = await this._loadDefragmentation({
        boardId: 736,
        projectId: this.projectId,
        page: 1,
        perPage: 500,
        orderTarget: "created_at",
        orderDirection: "desc",
        withMeta: true,
        onlyMeta: true,
        withoutRelation: true,
        metaKeys: ["body.사업장.id", "body.사업장.field_name", "body.팀명", "body.공장명", "body.대분류", "body.중분류", "body.소분류"],
      });

      let allList = list.map((data) => {
        const postContents = data.postContents;
        const body = postContents.body;
        const 사업장 = body.사업장 ? {id: body.사업장.id, field_name: body.사업장.field_name} : {id: 0, field_name: ''};
        const 팀명 = body.팀명;
        const 공장명 = body.공장명;
        const 대분류 = body.대분류;
        const 중분류 = body.중분류;
        const 소분류 = body.소분류;

        return {
          사업장,
          팀명,
          공장명,
          대분류,
          중분류,
          소분류,
        }
      });
      allList = allList.filter((data) => {
        for (const search of searchList) {
          // 모든 데이터가 일치하는 경우만 반환
          if (
            `${search.사업장.id}` === `${data.사업장.id}` &&
            search.팀명 === data.팀명 &&
            search.공장명 === data.공장명 &&
            search.대분류 === data.대분류 &&
            search.중분류 === data.중분류 &&
            search.소분류 === data.소분류
          ) {
            return true;
          }
        }
        return false;
      })
      this.loading(false)

      return allList;
    },
    // 전체 목록을 다운로드 받기 위해 사용
    async _loadDefragmentation(options) {
      const response = await this.$store.dispatch("board/LOAD_POST_LIST", options);
      const list = [];
      list.push(...response.data);
      if (response.current_page !== response.last_page) {
        options.page = response.current_page + 1;
        list.push(...(await this._loadDefragmentation(options)));
      }
      return list;
    },
    async loadPostOptions(사업장, 팀명, 공장명, 대분류, 중분류) {
      const keywords = [];
      keywords.push(사업장 ? 사업장 : '');
      keywords.push(팀명 ? 팀명 : '');
      keywords.push(공장명 ? 공장명 : '');
      keywords.push(대분류 ? 대분류 : '');
      keywords.push(중분류 ? 중분류 : '');

      const cacheKey = this.getCacheKey(사업장, 팀명, 공장명, 대분류, 중분류);

      if (!this.options['body.팀명'][cacheKey] && !this.options['body.공장명'][cacheKey] && !this.options['body.대분류'][cacheKey] && !this.options['body.중분류'][cacheKey]) {
        const response = await HttpRequest.get("/api/v1/post/options", {
          params: {
            boardId: 736,
            options: ["body.사업장.field_name", "body.팀명", "body.공장명", "body.대분류", "body.중분류"],
            keywords,
          },
        });

        this.$set(this.options['body.팀명'], cacheKey, response['body.팀명']);
        this.$set(this.options['body.공장명'], cacheKey, response['body.공장명']);
        this.$set(this.options['body.대분류'], cacheKey, response['body.대분류']);
        this.$set(this.options['body.중분류'], cacheKey, response['body.중분류']);
      }

      return this.options;
    },
    getCacheKey(사업장, 팀명, 공장명, 대분류, 중분류) {
      return `736_post_options_${사업장},${팀명},${공장명},${대분류},${중분류}`;
    },
    // 오버레이 표시
    async showOverlay(event, field, rowIndex, data) {
      // 기존 timeout 취소
      if (this.overlayTimeout) {
        clearTimeout(this.overlayTimeout);
        this.overlayTimeout = null;
      }

      const target = event.target;
      // input 요소가 vs-input 안에 중첩되어 있으므로 실제 input 요소를 찾아야 함
      const inputElement = target.querySelector('input') || target;
      const rect = inputElement.getBoundingClientRect();

      // popup 컨테이너 기준으로 상대적 위치 계산
      const popupElement = document.querySelector('#popupCreate736 .vs-popup');
      const popupRect = popupElement ? popupElement.getBoundingClientRect() : { top: 0, left: 0 };
      const bodyElement = document.querySelector('.body');
      const scrollTop = bodyElement ? bodyElement.scrollTop : 0;

      // 현재 포커스된 필드는 빈 값으로 처리하여 모든 옵션 조회
      const queryData = {
        사업장: data.사업장.field_name,
        팀명: field === '팀명' ? '' : data.팀명,
        공장명: field === '공장명' ? '' : data.공장명,
        대분류: field === '대분류' ? '' : data.대분류,
        중분류: field === '중분류' ? '' : data.중분류,
      };

      // 해당 필드의 모든 옵션을 조회하기 위해 API 호출
      await this.loadPostOptions(
        queryData.사업장,
        queryData.팀명,
        queryData.공장명,
        queryData.대분류,
        queryData.중분류
      );

      const cacheKey = this.getCacheKey(
        queryData.사업장,
        queryData.팀명,
        queryData.공장명,
        queryData.대분류,
        queryData.중분류
      );

      // 해당 필드의 옵션들 가져오기
      const fieldOptions = this.options[`body.${field}`][cacheKey] || [];
      const optionArray = Array.isArray(fieldOptions) ? fieldOptions : Object.keys(fieldOptions);

      this.overlay = {
        show: true,
        field,
        rowIndex,
        options: optionArray,
        filteredOptions: optionArray, // 초기에는 모든 옵션 표시
        position: {
          top: rect.bottom - popupRect.top + scrollTop,
          left: rect.left - popupRect.left,
          width: rect.width
        }
      };
    },
    // 옵션 필터링
    filterOptions(inputValue, field) {
      if (!this.overlay.show || this.overlay.field !== field) return;

      const searchText = (inputValue || '').toLowerCase();
      if (searchText === '') {
        this.overlay.filteredOptions = this.overlay.options;
      } else {
        this.overlay.filteredOptions = this.overlay.options.filter(option => option.toLowerCase().includes(searchText)
        );
      }
    },
    // 오버레이 숨기기 (포커스 아웃 시 API 호출)
    async hideOverlay(event, field, rowIndex, data) {
      // 포커스 아웃 시 API 호출하여 옵션 갱신
      if (field && data) {
        await this.loadPostOptions(
          data.사업장.field_name,
          data.팀명,
          data.공장명,
          data.대분류,
          data.중분류
        );
      }

      this.overlayTimeout = setTimeout(() => {
        this.overlay.show = false;
        this.overlayTimeout = null;
      }, 200); // 클릭 이벤트가 먼저 처리되도록 딜레이
    },
    // 옵션 선택
    selectOption(option) {
      // timeout 취소
      if (this.overlayTimeout) {
        clearTimeout(this.overlayTimeout);
        this.overlayTimeout = null;
      }

      if (this.overlay.rowIndex >= 0 && this.overlay.field) {
        this.list[this.overlay.rowIndex][this.overlay.field] = option;
      }
      this.overlay.show = false;
    },
    pushRow () {
      if (this.list.length === 0) {
        this.list.push({
          사업장: {id: 0, field_name: ''},
          팀명: '',
          공장명: '',
          대분류: '',
          중분류: '',
          소분류: '',
        })
      } else {
        this.list.push({
          사업장: JSON.parse(JSON.stringify(this.list[this.list.length - 1].사업장)),
          팀명: this.list[this.list.length - 1].팀명,
          공장명: this.list[this.list.length - 1].공장명,
          대분류: '',
          중분류: '',
          소분류: '',
        });
      }
    },
    popRow () {
      if (this.list.length > 1) {
        // 2개 이상의 행이 있을 때만 삭제
        this.list.pop()
      } else if (this.list.length === 1) {
        // 마지막 행인 경우, 기존 행을 삭제하고 새 행 추가
        this.list.pop()
        this.pushRow()
      }
    },
    async onClickSave () {
      // 데이터 검증
      const validationResult = this.validateData();
      if (!validationResult.isValid) {
        this.$vs.notify({
          title: '입력 오류',
          text: validationResult.message,
          color: 'danger',
          position: 'top-right'
        });
        return;
      }

      const allList = await this.loadPostListWithMeta(this.list);

      // 중복 제거
      const uniqueList = this.list.filter((data, index, self) => {
        return index === self.findIndex((t) => (
          `${t.사업장.id}` === `${data.사업장.id}` &&
          `${t.팀명}`.trim() === `${data.팀명}`.trim() &&
          `${t.공장명}`.trim() === `${data.공장명}`.trim() &&
          `${t.대분류}`.trim() === `${data.대분류}`.trim() &&
          `${t.중분류}`.trim() === `${data.중분류}`.trim() &&
          `${t.소분류}`.trim() === `${data.소분류}`.trim()
        ));
      });

      // 중복 제거 후 전체 목록과 비교하여 중복 제거
      const uniqueList2 = uniqueList.filter((data) => {
        return !allList.some((t) => (
          `${t.사업장.id}` === `${data.사업장.id}` &&
          `${t.팀명}`.trim() === `${data.팀명}`.trim() &&
          `${t.공장명}`.trim() === `${data.공장명}`.trim() &&
          `${t.대분류}`.trim() === `${data.대분류}`.trim() &&
          `${t.중분류}`.trim() === `${data.중분류}`.trim() &&
          `${t.소분류}`.trim() === `${data.소분류}`.trim()
        ));
      });

      if (uniqueList2.length > 0) {
        this.writeOnClickSaveMultiple({
          posts: this.list.map((data) => {
            return {
              stdInfo: this.stdInfo,
              ...data
            }
          }),
          callback: (result) => {
            if (result) {
              this.$vs.notify({
                title: '저장완료',
                text: `${uniqueList2.length}건 저장되었습니다.`,
                color: 'success',
                position: 'top-right'
              })

              this.$emit('save')
              this.showPopup = false;
            }
          },
        });
      } else {
        this.$vs.notify({
          title: '저장완료',
          text: '0건 저장되었습니다.',
          color: 'success',
          position: 'top-right'
        })

        this.$emit('save')
        this.showPopup = false;
      }
    },

    // 데이터 검증 메서드
    validateData() {
      if (this.list.length === 0) {
        return {
          isValid: false,
          message: '등록할 데이터가 없습니다. 행을 추가해주세요.'
        };
      }

      for (let i = 0; i < this.list.length; i++) {
        const data = this.list[i];
        const rowNumber = i + 1;

        // 사업장명 검증
        if (!data.사업장.id || data.사업장.id === 0 || !data.사업장.field_name.trim()) {
          return {
            isValid: false,
            message: `${rowNumber}번째 행의 사업장명을 선택해주세요.`
          };
        }

        // 팀명 검증
        if (!data.팀명 || !data.팀명.trim()) {
          return {
            isValid: false,
            message: `${rowNumber}번째 행의 팀명을 입력해주세요.`
          };
        }

        // 공장명 검증
        if (!data.공장명 || !data.공장명.trim()) {
          return {
            isValid: false,
            message: `${rowNumber}번째 행의 공장명을 입력해주세요.`
          };
        }

        // 대분류 검증
        if (!data.대분류 || !data.대분류.trim()) {
          return {
            isValid: false,
            message: `${rowNumber}번째 행의 대분류를 입력해주세요.`
          };
        }

        // 중분류 검증
        if (!data.중분류 || !data.중분류.trim()) {
          return {
            isValid: false,
            message: `${rowNumber}번째 행의 중분류를 입력해주세요.`
          };
        }

        // 소분류 검증
        if (!data.소분류 || !data.소분류.trim()) {
          return {
            isValid: false,
            message: `${rowNumber}번째 행의 소분류를 입력해주세요.`
          };
        }
      }

      return {
        isValid: true,
        message: ''
      };
    },
    loading(open) {
      const loadingDialog = new CustomEvent("loadingDialog", {
        detail: {
          open,
        },
      });
      window.dispatchEvent(loadingDialog);
    },

    writeOnClickSaveMultiple(forms) {
      const boardId = 736;
      this.loading(true);
      const date = new Date();
      const header = {...this.header, full: date.format("yyyy-MM-dd")};
      const posts = forms.posts.map((form) => {
        const content = {
          header,
          body: {
            ...form
          },
        };
        return {
          title: this.pageTitle,
          content: JSON.stringify(content),
          projectId: this.projectId,
          company_member_join: true,
        }
      });
      HttpRequest.put(`/api/v1/board/post/${boardId}/multiple`, { posts })
        .then((response) => {
          if (forms.callback) {
            forms.callback(true, response);
          }

          this.loading(false);
        })
        .catch(({ response }) => {
          if (forms.callback) {
            forms.callback(false, response);
          }
          this.loading(false);
        });
    },
  }
}
</script>

<style scoped lang="scss">
.body {
  height: 553px;
  overflow-y: scroll;
  border-bottom: 1px solid #cdcdcd;
  background: #FAFAFA;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
  min-width: 800px;

  thead {
    position: sticky;
    top: 0;
  }

  th{
    font-weight: bold;
    text-align: center;
    padding: 0;
    min-width: 150px;

    & > div {
      padding: 10px 4px;
      border-top: 1px solid #cdcdcd;
      border-bottom: 1px solid #cdcdcd;
    }
  }
  th,
  td {
    background: #F9F9F9;
    border-right: 1px solid #cdcdcd;
    &:last-child {
      border-right: none;
    }
  }

  td {
    padding: 4px;
    border-bottom: 1px solid #cdcdcd;
  }
}

.options-overlay {
  position: absolute;
  background: white;
  border: 1px solid #cdcdcd;
  border-radius: 4px;
  max-height: 200px;
  overflow-y: auto;
  z-index: 1000;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  .option-item {
    padding: 8px 12px;
    cursor: pointer;
    border-bottom: 1px solid #f0f0f0;

    &:hover {
      background-color: #f5f5f5;
    }

    &:last-child {
      border-bottom: none;
    }

    &.disabled {
      color: #999;
      cursor: default;

      &:hover {
        background-color: white;
      }
    }
  }
}

.header {
  button {
    width: 32px;
    height: 32px;

    display: flex;
    align-items: center;
    justify-content: center;

    color: #7e72f2;
    background: none;
    border: 1px solid #7e72f2;
    border-radius: 4px;
    cursor: pointer;

    span {
      margin: 0;
    }
  }
}

</style>

<style>
#popupCreate736 > .vs-popup {
  width: 1600px !important;
}

</style>
